import React from 'react';

interface DateFormatProps {
  text: string;
}

const DateFormat2: React.FC<DateFormatProps> = ({ text }) => {
  if (!text) return null;

  const isUTC = text.endsWith('Z');
  const date = new Date(isUTC ? text : `${text}Z`);

  if (isNaN(date.getTime())) return null;

  const nepalTime = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kathmandu',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);

  return <>{nepalTime}</>;
};

export default DateFormat2;
